import React from 'react';
import { Route } from 'react-router';
// @ts-ignore
import Config from 'Config';

import CoachingChatStreamContainer from 'coaching/CoachingChatStreamContainer';
import CoachingConstants from 'coaching/CoachingConstants';
import CoachingCoordinatorContainer from 'coaching/CoachingCoordinatorContainer';
import CoachingSelfServeContainer from 'coaching/CoachingSelfServeContainer';
import CoachingHomeContainer from 'coaching/CoachingHomeContainer';
import CoachingHelpContainer from 'coaching/CoachingHelpContainer';
import CoachingHelpFormContainer from 'coaching/CoachingHelpFormContainer';
import CoachingCoachHelpContainer from 'coaching/CoachingCoachHelpContainer';
import CoachingCoachHelpFormContainer from 'coaching/CoachingCoachHelpFormContainer';
import chainOnEnter, { ChainedFunction, InputChainedFunction } from 'components/lib/chainOnEnter';
// @ts-ignore
import RequireUser, { RequireUserFn } from 'lib/RequireUser';
// @ts-ignore
import RequireSetup from 'lib/RequireSetup';
import RequireLoginWithAuthToken from 'lib/RequireLoginWithAuthToken';
import Cookies from 'lib/Cookies';
import AcceptCoachingInvitation from 'coaching/components/AcceptCoachingInvitation';
import { redirectIfMobile, redirectIfDesktop } from 'coaching/lib/deviceType';
import {
  setShouldLoadFunnelTest,
  shouldLoadFunnelTest,
} from 'coaching/experiment/SignInFunnelExperiment';
import CoachDashboard from 'coaching/components/CoachDashboard';
import { LocationDescriptor } from 'lib/ReactRouterTypes';
import { RouterState } from 'lib/ReactRouterTypes';
// @ts-ignore
import AuthActions from 'auth/AuthActions';

/** Decorator/wrapper for an onEnter handler, that will skip it if the sign in funnel experiment has to be loaded,
  but execute it normally otherwise
 */
function ifNotLoadingFunnelTest(onEnterHandler: ChainedFunction) {
  const decoratedHandler: InputChainedFunction = (
    nextState: RouterState,
    replaceWith: (location: LocationDescriptor) => void,
    routerCallback?: () => void
  ) => {
    if (shouldLoadFunnelTest()) {
      routerCallback!();
    } else {
      return onEnterHandler(nextState, replaceWith, routerCallback);
    }
  };
  return decoratedHandler;
}

const RequireUserOrGeneralizedSignIn = RequireUserFn({ location: '/sign_in' });
export const CoachingIsolatedRoutes = (
  <>
    <Route
      path={'/coaching/review_edit'}
      component={CoachingSelfServeContainer}
      onEnter={chainOnEnter([RequireUserFn({ location: '/coaching/review' })])}
    />
    <Route
      path={CoachingConstants.COACHING_PURCHASE_REVIEW_SETUP_FINISHED_ROUTE}
      component={CoachingSelfServeContainer}
    />
    <Route
      path={CoachingConstants.COACHING_PURCHASE_REVIEW_ROUTE}
      component={CoachingSelfServeContainer}
      onEnter={chainOnEnter([
        () => {
          Cookies.set(CoachingConstants.IS_INTENDED_COACHING_USER_COOKIE, 'true', { expires: 1 });
        },
        RequireUserOrGeneralizedSignIn,
        RequireSetup,
      ])}
    />
    <Route
      path={CoachingConstants.COACHING_COORDINATOR_ROUTE}
      component={CoachingCoordinatorContainer}
      onEnter={RequireUser}
    />
    <Route
      path={CoachingConstants.COACHING_ACCEPT_INVITATION_ROUTE}
      onEnter={chainOnEnter([RequireLoginWithAuthToken, RequireUser, RequireSetup])}
      component={AcceptCoachingInvitation}
    />
    {/* No left nav bar on mobile home */}
    <Route
      path={CoachingConstants.COACHING_HOME_MOBILE_ROUTE}
      component={CoachingHomeContainer}
      onEnter={chainOnEnter([
        redirectIfDesktop(CoachingConstants.COACHING_HOME_ROUTE),
        RequireUser,
      ])}
    />
    <Route
      path={CoachingConstants.COACHING_BILLING_MOBILE_ROUTE}
      component={CoachingHomeContainer}
      onEnter={chainOnEnter([
        redirectIfDesktop(CoachingConstants.COACHING_BILLING_ROUTE),
        RequireUser,
      ])}
    />
    <Route
      path={CoachingConstants.COACHING_SCHEDULE_MOBILE_ROUTE}
      component={CoachDashboard}
      onEnter={chainOnEnter([
        redirectIfDesktop(CoachingConstants.COACHING_SCHEDULE_ROUTE),
        RequireUser,
      ])}
    />
    <Route
      path={CoachingConstants.COACHING_AVAILABILITY_MOBILE_ROUTE}
      component={CoachDashboard}
      onEnter={chainOnEnter([
        redirectIfDesktop(CoachingConstants.COACHING_AVAILABILITY_ROUTE),
        RequireUser,
      ])}
    />
    <Route path={CoachingConstants.COACHING_HELP_ROUTE} component={CoachingHelpContainer} />
    <Route
      path={CoachingConstants.COACHING_HELP_FORM_ROUTE}
      component={CoachingHelpFormContainer}
    />
    <Route
      path={CoachingConstants.COACHING_COACH_HELP_ROUTE}
      component={CoachingCoachHelpContainer}
    />
    <Route
      path={CoachingConstants.COACHING_COACH_HELP_FORM_ROUTE}
      component={CoachingCoachHelpFormContainer}
    />
  </>
);

export const CoachingRoutes = (
  <>
    <Route
      path={CoachingConstants.COACHING_CHAT_STREAM_ROUTE}
      component={CoachingChatStreamContainer}
      onEnter={RequireUser}
    />
    <Route
      path={CoachingConstants.COACHING_SCHEDULE_ROUTE}
      component={CoachDashboard}
      onEnter={chainOnEnter([
        redirectIfMobile(CoachingConstants.COACHING_SCHEDULE_MOBILE_ROUTE),
        RequireUser,
      ])}
    />
    <Route
      path={CoachingConstants.COACHING_AVAILABILITY_ROUTE}
      component={CoachDashboard}
      onEnter={chainOnEnter([
        redirectIfMobile(CoachingConstants.COACHING_AVAILABILITY_MOBILE_ROUTE),
        RequireUser,
      ])}
    />
    <Route
      path={CoachingConstants.COACHING_HOME_ROUTE}
      component={CoachingHomeContainer}
      onEnter={chainOnEnter([
        redirectIfMobile(CoachingConstants.COACHING_HOME_MOBILE_ROUTE),
        RequireUser,
      ])}
    />
    <Route
      path={CoachingConstants.COACHING_BILLING_ROUTE}
      component={CoachingHomeContainer}
      onEnter={chainOnEnter([
        redirectIfMobile(CoachingConstants.COACHING_BILLING_MOBILE_ROUTE),
        RequireUser,
      ])}
    />
  </>
);
